// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2JzpG","modalForm":"UpgradeEpcsModal_modalForm__1-m-2","modalFooter":"UpgradeEpcsModal_modalFooter__2t4UE"};